class PromotionCodes {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/promotion-codes`;

  }

  async createAmountOffPromotionCode(promotionCode) {

    const path = `${this.basePath}/amount-off`;

    return this.apiClient.post(path, {}, {}, promotionCode);

  }

  async createPercentOffPromotionCode(promotionCode) {

    const path = `${this.basePath}/percent-off`;

    return this.apiClient.post(path, {}, {}, promotionCode);

  }

  async getPromotionCodesByQueryOptions() {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, {});

  }

  async deletePromotionCode(promotionCodeId) {

    const path = `${this.basePath}/:promotionCodeId`;

    return this.apiClient.delete(path, { promotionCodeId }, {}, {});

  }

}

export default PromotionCodes;